<template>
  <div class="fu-card">
    <div class="fu-icon-wrap">
      <i class="fa fu-icon" :class="icon"></i>
    </div>
    <h2 class="fu-headline">{{ headline }}</h2>
    <p class="fu-sub">{{ sub }}</p>
    <ul class="fu-list">
      <li v-for="item in items" :key="item.label">
        <i class="fa fa-check-circle"></i>
        <span class="fu-item">
          <strong class="fu-item-label">{{ item.label }}</strong>
          <span class="fu-item-desc">{{ item.desc }}</span>
        </span>
      </li>
    </ul>
    <router-link
      :to="{ name: 'support_ticket_create', query: { category: category, subject: subject } }"
      class="btn fu-cta"
    >
      <i class="fa fa-ticket"></i> Open a support ticket
    </router-link>
  </div>
</template>

<script>
// the feature-lock pitch card shown when a tenant's package doesn't include
// a section (alerts / reports / vsm). copy comes in as props so each shell
// owns its own pitch; the cta pre-fills the support ticket category+subject.
export default {
  name: 'feature_upsell',
  props: {
    icon: { type: String, required: true },
    headline: { type: String, required: true },
    sub: { type: String, required: true },
    items: { type: Array, required: true },
    category: { type: String, required: true },
    subject: { type: String, required: true },
  },
}
</script>

<style scoped>
.fu-card {
  max-width: 640px;
  margin: 40px auto;
  text-align: center;
  padding: 40px 32px;
  border: 1px solid var(--fi-upsell-border);
  border-radius: 10px;
  background: var(--fi-upsell-bg);
}
.fu-icon-wrap { margin-bottom: 16px; }
.fu-icon { font-size: 48px; color: var(--fi-rail-accent); }
.fu-headline { font-size: 24px; font-weight: bold; color: var(--fi-text); margin-bottom: 10px; }
.fu-sub { font-size: 15px; color: var(--fi-text-muted); max-width: 460px; margin: 0 auto 24px; }
.fu-list { list-style: none; padding: 0; margin: 0 0 28px; text-align: left; display: inline-block; }
.fu-list li { display: flex; align-items: flex-start; gap: 10px; margin-bottom: 14px; }
.fu-list .fa-check-circle { color: var(--fi-rail-accent); font-size: 16px; margin-top: 3px; flex-shrink: 0; }
.fu-item { display: flex; flex-direction: column; }
.fu-item-label { font-size: 14px; color: var(--fi-text); }
.fu-item-desc { font-size: 13px; color: var(--fi-text-muted); }
.fu-cta {
  background-color: var(--fi-action-primary);
  color: #fff !important;
  font-size: 15px;
  font-weight: bold;
  padding: 10px 28px;
  border-radius: 6px;
  text-decoration: none;
  border: none;
}
.fu-cta:hover {
  box-shadow: inset 0 0 0 999px rgba(0, 0, 0, 0.14);
  color: #fff !important;
  text-decoration: none;
}
.fu-cta:focus {
  box-shadow: inset 0 0 0 999px rgba(0, 0, 0, 0.14), 0 0 0 0.2rem var(--fi-action-primary-ring);
  color: #fff !important;
  text-decoration: none;
}
.fu-cta .fa { margin-right: 6px; }
</style>
